<app-header-user> </app-header-user>
<section class="account-page mrgn-top greybg py-5">
    <div class="container"> 
     <div class="">
      <div class="row mt-2 mt-md-0"> 
  
          <aside class="col-sm-12 col-md-12 col-lg-12">
                      </aside>
                      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">

                        <div class="row">
                            <div class="col-md-6"> <h6> {{ 'myaccount.track_order' | translate }} </h6> </div>
                        </div>

                        <div class="row mb-3 order-numdelivery">
                          <div class="col-md-6">
                            <p>{{ 'trackorder.order_id' | translate }}</p>
                            <h5> <a [routerLink]="['/my-account/order-details', ordDetail['orderid']]"> {{ordDetail['orderid']}} </a> </h5>
                          </div>

                          <div class="col-md-6 text-right" *ngIf="showEsmDelivery">
                            <p>{{ 'trackorder.est_delivery' | translate }}</p>
                            <countdown [config]="{leftTime:countSec}"></countdown>
                          </div>

                          <div class="col-md-6 text-right" *ngIf="showSdelivery">
                            <p>{{ 'trackorder.s_delivery' | translate }}</p>
                            <p>{{ 'trackorder.date' | translate }}: {{ordDetail['sdate']}}</p>
                            <p>{{ 'trackorder.time' | translate }}: {{ordDetail['time_from']}} TO {{ordDetail['time_to']}} </p>
                          </div>

                        </div>
                        <hr>
                       
                         <div class="row">
                            <div class="col-md-12  mb-3 mt-md-2 order-tracker">
                                <ol class="progtrckr" data-progtrckr-steps="5">
                                  <li 
                                  class="progtrckr-todo" 
                                  appOrdertrack [ostid]="ost.id" [oCrntStates]="odrCStates"
                                  *ngFor="let ost of allOStates">
                                    <div class="ostscnt" >
                                      <p *ngIf="showLang == 'en'" >{{ost.value}} </p>
                                      <p *ngIf="showLang == 'ar'">{{ost.value_ar}} </p>
                                      <p *ngIf="showLang == 'en'" class="ordstatus"> {{ost.stsDetail}} </p>
                                      <p *ngIf="showLang == 'ar'" class="ordstatus"> {{ost.stsDetail_ar}} </p>
                                    </div>
                                    <hr>
                                  </li>                 
                                </ol>
                             </div> 
                             <div class="col-md-12">
                              <div class="profile-content del-add h-100">
                                <h3>{{ 'trackorder.d_address' | translate }}  </h3>
                                <p>
                                  <strong>{{ordDetail['uName']}}</strong><br>
                                 {{ordDetail['address_one']}}, {{ordDetail['address_two']}},
                                  <br> {{ordDetail['city']}},{{ordDetail['state']}},{{ordDetail['country']}}
                                </p>
                             </div>
                         </div>

   </div>


</div>
                  </div>
              </div>
          </div>
      </section>